import {Color} from 'three'

export const colors = {
  orange: new Color(0xc05200),
  brown: new Color(0xa64c3e),
  baige: new Color(0xf5f0eb),
  blue: new Color(0x583af7),
  yellow: new Color(0xbba00a),
  purple: new Color(0xae85ff),
  white: new Color(0xffffff),
  pink: new Color(0xf73678),
  green: new Color(0x5fed83),
  black: new Color(0x180e27),
}

export type RectData = {
  rowIndex: number
  colIndex: number
  color: Color
}

const defaultCol = 7.75

export const rectDatas_fromLeft_small: RectData[] = [
  {
    colIndex: defaultCol + 0,
    rowIndex: 0,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 1,
    rowIndex: 0,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 2,
    rowIndex: 3,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 2,
    rowIndex: 1,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 3,
    rowIndex: 2,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 4,
    rowIndex: 5,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 4,
    rowIndex: 0,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 5,
    rowIndex: 3,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 5,
    rowIndex: 1,
    color: colors.baige,
  },
  {
    colIndex: defaultCol + 6,
    rowIndex: 4,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 6,
    rowIndex: 1,
    color: colors.purple,
  },
  {
    colIndex: defaultCol + 6,
    rowIndex: 0,
    color: colors.baige,
  },
  {
    colIndex: defaultCol + 7,
    rowIndex: 3,
    color: colors.baige,
  },
  {
    colIndex: defaultCol + 7,
    rowIndex: 2,
    color: colors.pink,
  },
  {
    colIndex: defaultCol + 7,
    rowIndex: 1,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 7,
    rowIndex: 0,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 8,
    rowIndex: 4,
    color: colors.pink,
  },
  {
    colIndex: defaultCol + 8,
    rowIndex: 3,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 8,
    rowIndex: 2,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 8,
    rowIndex: 1,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 8,
    rowIndex: 0,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 9,
    rowIndex: 5,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 9,
    rowIndex: 4,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 9,
    rowIndex: 3,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 9,
    rowIndex: 2,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 9,
    rowIndex: 1,
    color: colors.brown,
  },
  {
    colIndex: defaultCol + 9,
    rowIndex: 0,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 10,
    rowIndex: 5,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 10,
    rowIndex: 4,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 10,
    rowIndex: 3,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 10,
    rowIndex: 2,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 10,
    rowIndex: 1,
    color: colors.orange,
  },
  {
    colIndex: defaultCol + 10,
    rowIndex: 0,
    color: colors.orange,
  },
  {
    colIndex: defaultCol + 11,
    rowIndex: 5,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 11,
    rowIndex: 4,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 11,
    rowIndex: 3,
    color: colors.baige,
  },
  {
    colIndex: defaultCol + 11,
    rowIndex: 2,
    color: colors.orange,
  },
  {
    colIndex: defaultCol + 11,
    rowIndex: 1,
    color: colors.baige,
  },
  {
    colIndex: defaultCol + 11,
    rowIndex: 0,
    color: colors.pink,
  },
  {
    colIndex: defaultCol + 12,
    rowIndex: 5,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 12,
    rowIndex: 4,
    color: colors.orange,
  },
  {
    colIndex: defaultCol + 12,
    rowIndex: 3,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 12,
    rowIndex: 2,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 12,
    rowIndex: 1,
    color: colors.purple,
  },
  {
    colIndex: defaultCol + 12,
    rowIndex: 0,
    color: colors.pink,
  },
  {
    colIndex: defaultCol + 13,
    rowIndex: 5,
    color: colors.pink,
  },
  {
    colIndex: defaultCol + 13,
    rowIndex: 4,
    color: colors.orange,
  },
  {
    colIndex: defaultCol + 13,
    rowIndex: 3,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 13,
    rowIndex: 2,
    color: colors.green,
  },
  {
    colIndex: defaultCol + 13,
    rowIndex: 1,
    color: colors.purple,
  },
  {
    colIndex: defaultCol + 13,
    rowIndex: 0,
    color: colors.blue,
  },
  {
    colIndex: defaultCol + 14,
    rowIndex: 5,
    color: colors.purple,
  },
  {
    colIndex: defaultCol + 14,
    rowIndex: 4,
    color: colors.white,
  },
  {
    colIndex: defaultCol + 14,
    rowIndex: 3,
    color: colors.purple,
  },
  {
    colIndex: defaultCol + 14,
    rowIndex: 2,
    color: colors.black,
  },
  {
    colIndex: defaultCol + 14,
    rowIndex: 1,
    color: colors.black,
  },
  {
    colIndex: defaultCol + 14,
    rowIndex: 0,
    color: colors.pink,
  },
]
